import { Box, Center, Grid, Text } from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import { generateLevels } from "../utils/function";
import AutoCrop from "App/BsesPoc/components/imageCropping/AutoCrop";
import { poExtractionTypes } from "../utils/constant";
import { useContext } from "react";
import { AppContext } from "AppProvider/AppContext";

const WorkFlowDesc = ({
  activePage,
  showError,
  errors,
  values,
  handleChange,
  isDisabled,
  handleOpenModal,
  generateApprovalsArray,
  setFieldValue,
  handleLogoChange,
}: any) => {
  const { workflowProcess } = useContext(AppContext)
  return (
    <Box display={activePage === 0 ? undefined : "none"}>
      <Grid gap={6} templateColumns={{ md: "1fr 1fr" }}>
        <CustomInput
          label="WorkFlow Name"
          name="workFlowName"
          placeholder="Enter the WorkFlow Name"
          error={errors.workFlowName}
          value={values.workFlowName}
          onChange={handleChange}
          showError={showError}
          disabled={isDisabled}
        />
        <CustomInput
          label="Flow Name"
          name="flowName"
          placeholder="Enter the Flow Name"
          error={errors.flowName}
          value={values.flowName}
          onChange={handleChange}
          showError={showError}
          disabled={isDisabled}
        />
        {/* <CustomInput
          label="Identifier"
          name="identifier"
          error={errors.name}
          value={values.identifier}
          onChange={handleChange}
          showError={showError}
          disabled={true}
        /> */}
        <CustomInput
          label="Enter the No. of Levels"
          type="number"
          name="levels"
          placeholder="Enter the No. of Levels"
          value={values.levels}
          onChange={(e) => {
            const inputValue = e.target.value;

            if (inputValue) {
              const parsedValue = parseInt(inputValue, 10);

              if (!isNaN(parsedValue) && parsedValue >= 1) {
                generateApprovalsArray(setFieldValue, values, parsedValue);
                setFieldValue(`triggers[0].level`, generateLevels(parsedValue));
              }
            } else {
              setFieldValue("levels", "");
              setFieldValue(`triggers[0].level`, []);
            }

            handleChange(e);
          }}
          error={errors.levels}
          showError={showError}
          disabled={isDisabled}
        />

        {['domestic', 'zuventus'].includes(workflowProcess?.processName?.toLowerCase()) && <CustomInput
          type="select"
          label="Select Department"
          name="documentType"
          options={['domestic', 'zuventus'].includes(workflowProcess?.processName?.toLowerCase()) ?
            workflowProcess?.processName?.toLowerCase() === "zuventus" ? [
              {
                "label": "IT Infrastructure",
                "value": "it_infrastructure"
              },
              {
                "label": "Information Security",
                "value": "information_security"
              },
              {
                "label": "Application and Digitization",
                "value": "application_and_digitization"
              }
            ] :
              [
                {
                  "label": "IT Infrastructure",
                  "value": "it_infrastructure"
                },
                {
                  "label": "Information Security",
                  "value": "information_security"
                },
                {
                  "label": "Application and Digitization",
                  "value": "application_and_digitization"
                },
                {
                  "label": "SAP",
                  "value": "sap"
                },
                {
                  "label": "Artificial Intelligence",
                  "value": "artificial_intelligence"
                },
                {
                  "label": "IT Compliance",
                  "value": "it_compliance"
                }
              ] : []}
          placeholder="Enter the Document type"
          value={values.documentType}
          onChange={(e: any) => {
            setFieldValue('documentType', e);

            const parts = values.workFlowName?.split('-') || [];

            const email = parts[0] || '';
            const profileId = parts[1] || '';


            if (!email || !profileId) return;

            let workflowProcessee = workflowProcess?.processName?.toLowerCase() === "zuventus" ? "Zuventus" : "Domestic";
            const updatedWorkflow = `${email}-${profileId}-${e?.value}-${workflowProcessee}`;

            setFieldValue('workFlowName', updatedWorkflow);
          }}
          showError={showError}
          isBoxSelect
          disabled={isDisabled}
        />}

        {/* Process Type as Select */}
        <CustomInput
          label="Process Name"
          name="processName"
          type="select"
          placeholder="Enter Process Name"
          value={values.processName}
          onChange={(e) => setFieldValue('processName', e)}
          showError={showError}
          disabled={isDisabled}
          isBoxSelect
          options={[
            { label: "Domestic", value: "domestic" },
            { label: "Emerging", value: "emerging" },
            { label: "Marcan", value: "marcan" },
            { label: "Tillomed", value: "tillomed" },
            { label: "pando", value: "pando" },
            { label: "mmt", value: "mmt" },
            { label: "provakil", value: "provakil" },
            { label: "Pr", value: "pr" },
            { label: "Sr", value: "sr" },
            { label: "Zuventus", value: "zuventus" }
          ]}
        />
        <CustomInput
          label="Process Type"
          name="processType"
          type="select"
          placeholder="Select Process Type"
          value={values.processType}
          onChange={(e) => setFieldValue('processType', e)}
          showError={showError}
          disabled={isDisabled}
          options={[
            { label: "Po", value: "Po" },
            { label: "NonPo", value: "NonPo" },
          ]}
        />
        {values?.processType?.value === "Po" && <CustomInput
          label="Po Extraction Type"
          name="poExtractionType"
          type="select"
          placeholder="Select Po Extraction Type"
          value={values.poExtractionType ? poExtractionTypes.find((it: any) => it.value === values?.poExtractionType) : poExtractionTypes[0]}
          onChange={(e) => { setFieldValue('poExtractionType', e.value) }}
          showError={showError}
          disabled={isDisabled}
          options={poExtractionTypes}
          isBoxSelect={true}
        />}
      </Grid>

      <Box display="none">
        <AutoCrop />
      </Box>

      <Grid mt={6}>
        <Center>
          <CustomInput
            type="file"
            name="logo"
            onChange={(e) => handleLogoChange(e, setFieldValue)}
            label="Upload Logo"
            rest={{ accept: "image/*" }}
            disabled={isDisabled}
          />
        </Center>
        {values && (
          <Box onClick={() => handleOpenModal(values.logo)}>
            <Text
              textDecoration={"underline"}
              color="blue.400"
              cursor="pointer"
            >
              {values?.logo?.name}
            </Text>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default WorkFlowDesc;
